<ng-content #cardHeader select="pxw-card-header,.pxw-card-header" />
<div
  #cardContent
  class="content"
  [ngClass]="{ 'scroll-enabled': contentScrollEnabled, 'with-padding': contentPaddingEnabled }"
>
  <ng-content></ng-content>
</div>
<ng-content #cardFooter select="pxw-card-footer,.pxw-card-footer" />
